import { create } from "zustand";
import { Content } from "@tiptap/react";

interface EditorState {
  editorContent: Record<string, Content>;
  setEditorContent: (campaignId: string, content: Content) => void;
  getEditorContent: (campaignId: string) => Content | undefined;
  clearEditorContent: (campaignId: string) => void;
  reset: () => void;
}

export const useEditorStore = create<EditorState>((set, get) => ({
  editorContent: {},

  setEditorContent: (campaignId: string, content: Content) =>
    set((state) => ({
      editorContent: { ...state.editorContent, [campaignId]: content },
    })),

  getEditorContent: (campaignId: string) => get().editorContent[campaignId],

  clearEditorContent: (campaignId: string) =>
    set((state) => {
      const { [campaignId]: _, ...rest } = state.editorContent;
      return { editorContent: rest };
    }),

  reset: () => set({ editorContent: {} }),
}));
